import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { Notification } from '../type';
import { useState } from 'react';
import { formatDate } from '../utils/dateUtils';

interface NotificationTableProps {
  data: Notification[];
  onNotificationSelect: (notification: Notification) => void;
}

export const NotificationTable = ({
  data,
  onNotificationSelect,
}: NotificationTableProps) => {

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const pagedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Box sx={{ width: '100%' }}>
      <TableContainer>
        <Table stickyHeader size="small">
                      <TableHead>
              <TableRow>
                <TableCell>알림 ID</TableCell>
                <TableCell>제목</TableCell>
                <TableCell>대상 타입</TableCell>
                <TableCell>상태</TableCell>
                <TableCell>예약 시각</TableCell>
                <TableCell>발송/실패 시각</TableCell>
                <TableCell>생성일</TableCell>
              </TableRow>
            </TableHead>
          <TableBody>
            {pagedData.map((row, index) => (
              <TableRow key={row.notificationId || `notification-${index}`} hover style={{ cursor: 'pointer' }} onClick={() => onNotificationSelect(row)}>
                <TableCell>{row.notificationId}</TableCell>
                <TableCell>{row.title}</TableCell>
                <TableCell>
                  {row.targetType === 'all' ? '전체' : 
                   row.targetType === 'token_list' ? '토큰 목록' :
                   row.targetType === 'approved_optional_users' ? '승인 + 선택약관 동의' :
                   row.targetType === 'topic' ? '토픽' :
                   row.targetType === 'user_list' ? '사용자 목록' : row.targetType}
                </TableCell>
                <TableCell>
                  <Box
                    sx={{
                      display: 'inline-block',
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: '0.75rem',
                      fontWeight: 'bold',
                      backgroundColor: row.status === 'sent' ? '#e8f5e8' : 
                                   row.status === 'pending' ? '#fff3e0' : '#ffebee',
                      color: row.status === 'sent' ? '#2e7d32' : 
                             row.status === 'pending' ? '#f57c00' : '#c62828',
                    }}
                  >
                    {row.status === 'sent' ? '발송됨' : 
                     row.status === 'pending' ? '대기중' : '실패'}
                  </Box>
                </TableCell>
                <TableCell>{formatDate(row.scheduledAt)}</TableCell>
                <TableCell>{(row.status === 'sent' && row.sentAt) ? formatDate(row.sentAt) : (row.status === 'failed' && row.failedAt) ? formatDate(row.failedAt) : '-'}</TableCell>
                <TableCell>{formatDate(row.createdAt)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
          component="div"
          count={data.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
    </Box>
  );
}; 
